export default __webpack_public_path__ + "static/media/birdSound.af3a1122.mp3";